import { makeStyles } from '@material-ui/core/styles';

const TEXT_LINE_HEIGHT = 18;
const TEXT_MIN_LINES = 2;

export const useStyles = makeStyles(
  () => ({
    root: {},
    tooltip: {
      maxWidth: 480,
    },
    description: {
      whiteSpace: 'pre-wrap',
      display: '-webkit-box',
      '-webkit-line-clamp': TEXT_MIN_LINES,
      '-webkit-box-orient': 'vertical',
      overflow: 'hidden',
      maxHeight: TEXT_LINE_HEIGHT * TEXT_MIN_LINES,
    },
  }),
  { name: 'CustomModelCard' }
);
